// extracted by mini-css-extract-plugin
module.exports = {"StockTradingSignalsPage":"trading-signals_StockTradingSignalsPage__6K6Al"};